
import React, { useMemo, useState } from 'react';
import { Search, X, User } from 'lucide-react';

const fmt = (v) => (!v || v === 'null' || v === 'undefined') ? '' : String(v).trim();

export default function EmployeePicker({ employees, value, onSelect, placeholder = 'Search employee by name or service no...' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen]   = useState(false);

  const selected = useMemo(
    () => (value ? employees.find(e => fmt(e.p_ced_service_no) === fmt(value)) : null),
    [employees, value]
  );

  const results = useMemo(() => {
    const q = query.toLowerCase().trim();
    if (!q) return employees.slice(0, 8);
    return employees.filter(e => {
      const name = `${fmt(e.p_first_name)} ${fmt(e.p_last_name)} ${fmt(e.p_report_name)}`.toLowerCase();
      const svc  = fmt(e.p_ced_service_no).toLowerCase();
      return name.includes(q) || svc.includes(q);
    }).slice(0, 8);
  }, [employees, query]);

  if (selected) {
    const name = fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`.trim();
    return (
      <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-3 py-2 shadow-sm w-fit">
        <div className="w-7 h-7 rounded-lg bg-slate-800 flex items-center justify-center shrink-0">
          <User size={13} className="text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-semibold text-gray-800 truncate max-w-[180px]">{name || 'Unknown'}</p>
          <p className="text-[10px] text-gray-400 font-mono">#{fmt(selected.p_ced_service_no)}</p>
        </div>
        <button onClick={() => onSelect(null)} className="ml-1 text-gray-400 hover:text-gray-600 shrink-0">
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <div className="relative w-72">
      <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
      <input
        value={query}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className="pl-8 pr-3 py-2 border border-gray-200 rounded-xl text-sm w-full focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 bg-white"
      />
      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1.5 w-full bg-white border border-gray-200 rounded-xl shadow-xl py-1.5 max-h-64 overflow-y-auto">
          {results.map((e) => {
            const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
            return (
              <button
                key={fmt(e.p_ced_service_no) || Math.random()}
                onMouseDown={() => { onSelect(fmt(e.p_ced_service_no)); setQuery(''); setOpen(false); }}
                className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-blue-50 transition-colors"
              >
                <span className="text-xs font-semibold text-gray-800 truncate flex-1">{name || 'Unknown'}</span>
                <span className="text-[10px] font-mono text-gray-400">#{fmt(e.p_ced_service_no)}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
